(() => {
  if (window.__lmcdSpiralBottomScript) return;
  window.__lmcdSpiralBottomScript = true;
  const selector = '[data-spiral-clone-reviews], [data-spiral-clone-footer]';

  const init = (root) => {
    if (root.dataset.spiralBottomReady === 'true') return;
    root.dataset.spiralBottomReady = 'true';
    const cleanup = [];
    const listen = (target, type, handler, options) => {
      if (!target) return;
      target.addEventListener(type, handler, options);
      cleanup.push(() => target.removeEventListener?.(type, handler, options));
    };

    const filter = root.querySelector('[data-review-filter]');
    const menu = root.querySelector('[data-review-filter-menu]');
    const modal = root.querySelector('[data-review-modal]');
    const close = () => {
      if (modal) modal.hidden = true;
      if (menu) menu.hidden = true;
      filter?.setAttribute('aria-expanded', 'false');
    };
    listen(filter, 'click', () => {
      const open = filter.getAttribute('aria-expanded') === 'true';
      filter.setAttribute('aria-expanded', String(!open));
      if (menu) menu.hidden = open;
    });
    listen(menu, 'click', (event) => {
      const button = event.target.closest('button');
      if (!button) return;
      const label = filter?.querySelector('span');
      if (label) label.textContent = button.textContent;
      close();
    });
    root.querySelectorAll('[data-review-media]').forEach((button) => listen(button, 'click', () => {
      const image = button.querySelector('img');
      if (!image || !modal) return;
      modal.querySelector('[data-review-modal-content]').replaceChildren(image.cloneNode());
      modal.hidden = false;
    }));
    root.querySelectorAll('[data-review-close]').forEach((button) => listen(button, 'click', close));
    const reviewCards = [...root.querySelectorAll('.spiral-clone-review-card')];
    root.querySelectorAll('.spiral-clone-review-card__play').forEach((icon) => {
      const button = icon.closest('button');
      const image = button?.querySelector('img');
      if (button) button.setAttribute('aria-label', 'View review image');
      if (image) image.alt = image.alt.replace(/^Video review/, 'Review media preview');
      icon.remove();
    });
    reviewCards.forEach((card, index) => { card.hidden = index >= 3; });
    listen(root.querySelector('[data-review-more]'), 'click', (event) => {
      reviewCards.forEach((card) => { card.hidden = false; });
      root.querySelector('.spiral-clone-reviews__grid')?.classList.add('is-expanded');
      event.currentTarget.remove();
    });
    if (filter || modal) listen(document, 'keydown', (event) => {
      if (event.key === 'Escape') close();
    });
    root.querySelectorAll('[data-footer-toggle]').forEach((button) => listen(button, 'click', () => {
      const item = button.closest('.spiral-clone-footer__column');
      const open = item.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(open));
      button.querySelector('span').textContent = open ? '−' : '＋';
    }));
    root.__spiralBottomTeardown = () => {
      cleanup.splice(0).forEach((remove) => remove());
      close();
      delete root.dataset.spiralBottomReady;
      delete root.__spiralBottomTeardown;
    };
  };

  const boot = () => document.querySelectorAll(selector).forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', (event) => {
    const node = event.target;
    if (node.matches?.(selector)) node.__spiralBottomTeardown?.();
    node.querySelectorAll?.(selector).forEach((root) => root.__spiralBottomTeardown?.());
  });
})();
